import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IFileStoreItem } from '../../documents/interfaces/IFileStoreItem';
import { CacheServiceService } from '../../services/cache-service.service';
import { FileUploadService } from './file-upload.service';
import { IFileInfo } from './interfaces/IFileInfo';
@Injectable()
export class CachedFileService{
    constructor(
        private fileStoreService:FileUploadService,
        private cacheService:CacheServiceService<IFileStoreItem>){
    }
    public Get(fileInfo: IFileInfo):Observable<IFileStoreItem>{
        const key = fileInfo.variant?`${fileInfo.id}-${fileInfo.variant}`:fileInfo.id;
        if(this.Exsists(fileInfo)){
            return this.cacheService.Get(key);
        }
        else if (fileInfo.variant){
            return this.fileStoreService.GetVariant(fileInfo);
        }
        else {
            return this.fileStoreService.Get(fileInfo);
        }
    }
    public Exsists(fileInfo: IFileInfo):boolean{
        const key = fileInfo.variant?`${fileInfo.id}-${fileInfo.variant}`:fileInfo.id;
        return this.cacheService.Exsists(key);
    }
    public Set(fileInfo: IFileStoreItem):void{        
        this.cacheService.Set(fileInfo.id, fileInfo);
    }
}